// Visual-identity layer for FAS Parts Warehouse. Three distinct directions are
// implemented behind a preview switch (?identity=1|2|3, persisted). Styling/identity
// only — no functional/data/permission changes.

export const LOGO_FULL = "/fas_logo_shield.png"; // FAS division shield — primary mark
export const LOGO_WHITE = "/fas_logo_shield.png"; // shield reads on dark; kept for API compatibility

// Optional real hero photo of the actual operation — owner supplies later.
// Drop a URL here (or set localStorage 'fas_hero_photo') and Bay Door renders it
// behind a dark scrim. Empty = premium photo-free industrial treatment.
export const HERO_PHOTO = "";

export function getHeroPhoto() {
  try {
    return localStorage.getItem("fas_hero_photo") || HERO_PHOTO;
  } catch {
    return HERO_PHOTO;
  }
}

export const BRAND = {
  portal: "FAS Parts Warehouse",
  division: "A Division of Friedrich's Auto Sales Inc",
  legal: "Friedrich's Auto & Truck",
  specialty: "Used Truck Parts & Equipment",
  heritage: "Est. 1954 · Family Owned & Operated",
  heritageShort: "Est. 1954",
  copyright: "FAS Parts Warehouse — A Division of Friedrich's Auto Sales Inc · Est. 1954",
};

export const DIRECTIONS = {
  1: { key: 1, name: "Modern Heritage", headerClass: "bg-white border-b border-slate-200" },
  2: { key: 2, name: "Industrial Precision", headerClass: "bg-zinc-950 border-b border-zinc-800" },
  3: { key: 3, name: "Classic Heavy-Duty", headerClass: "bg-slate-900 border-b border-slate-800" },
  4: { key: 4, name: "Bay Door", headerClass: "bg-zinc-950 border-b border-zinc-800" },
  5: { key: 5, name: "Spec Sheet", headerClass: "bg-zinc-950 border-b border-zinc-800" },
  6: { key: 6, name: "Forge", headerClass: "bg-zinc-950 border-b border-zinc-800" },
};

const STORE_KEY = "fas_identity";

export function getIdentity() {
  let v;
  try {
    const url = new URLSearchParams(window.location.search).get("identity");
    if (url) {
      v = parseInt(url, 10);
      if (DIRECTIONS[v]) localStorage.setItem(STORE_KEY, String(v));
    }
    if (!v) v = parseInt(localStorage.getItem(STORE_KEY), 10);
  } catch {
    /* ignore */
  }
  return DIRECTIONS[v] ? v : 4;
}
